import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const irService = {
    accountSearch: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}ir/account/search`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    accountSuspend: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}ir/account/submit/suspend`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
};

export default irService;